import { FC, ReactElement, useState } from 'react'

import { Button } from '@/components'
import { ImageViewer } from '@/compositions/ImageViewer/ImageViewer'
import { trans } from '@/helpers/trans'

import './ImageAttachmentPreview.scss'

interface ImageAttachmentPreviewProps {
    images: string[]
    className?: string
}

export const ImageAttachmentPreview: FC<ImageAttachmentPreviewProps> = ({
    images,
    className = '',
}): ReactElement | null => {
    const [isViewerOpen, setIsViewerOpen] = useState(false)

    if (! images.length) {
        return null
    }

    return (
        <>
            <Button
                type="button"
                text={trans('containers.newsfeedContainer.viewImage')}
                className={`image-attachment-preview ${className}`}
                onClick={() => setIsViewerOpen(true)}
            >
                <img className="image-attachment-preview__image" src={images[0]} alt="" />
                {images.length > 1 && (
                    <span className="image-attachment-preview__count">
                        +{images.length - 1}
                    </span>
                )}
            </Button>

            {isViewerOpen && (
                <ImageViewer
                    images={images}
                    onClose={() => setIsViewerOpen(false)}
                />
            )}
        </>
    )
}
